<section class="viewer-details__grid" [ngClass]="{ 'detail-opened': featureDetailStack.length > 0, 'detail-closed': !featureDetailStack?.length }">
  <div class="viewer-tree">
    <ebw-monorepo-feature-viewer-tree
      [features]="features"
      (nodeSecondaryAction)="onNodeSecondaryAction($event)"
      (nodeSelected)="onNodeSelection($event)"
    ></ebw-monorepo-feature-viewer-tree>
  </div>
  <div class="viewer-details__cards">
    <ng-container *ngIf="featureDetailStack.length === 0">
      <div class="info-box">
        <mat-icon class="info-box__icon">info_outline</mat-icon>
        <div class="info-box__text">Seleziona un elemento per visualizzare il suo dettaglio</div>
      </div>
    </ng-container>
    <ng-container *ngFor="let detail of featureDetailStack; let i = index">
      <div class="viewer-detail-card">
        <div class="viewer-detail-card__header">
          <div class="viewer-detail-card__title">
            {{ detail?.title }}
          </div>
          <button color="accent" mat-icon-button (click)="removeDetail(i)" *ngIf="featureDetailStack.length > 1">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="viewer-detail-card__body">
          <!-- Area info tabs (e.g. AreeMarketing layer) -->
          <ng-container *ngIf="detail.tabs; else standardDetail">
            <mat-tab-group>
              <mat-tab label="Geomarketing">
                <div class="tab-scroll">
                  <div class="disclaimer">
                    <span
                      ><b>Attenzione:</b> Il calcolo del valore dell'area è una stima generata da intelligenza artificiale e potrebbe contenere
                      imprecisioni</span
                    >
                  </div>
                  <div *ngIf="detail.tabs.prediction.length === 0" class="empty-message">Nessun dato per questa area</div>
                  <div *ngFor="let section of detail.tabs.prediction; let i = index" class="array-item">
                    <div class="array-item-header" (click)="togglePrediction(i)">
                      <span>{{ section.group }}</span>
                      <div class="array-item-actions">
                        <mat-icon (click)="copyPredictionContent(section); $event.stopPropagation()" title="Copia">content_copy</mat-icon>
                        <mat-icon>{{ isPredictionExpanded(i) ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </div>
                    </div>
                    <div class="array-item-body" *ngIf="isPredictionExpanded(i)">
                      <div *ngFor="let item of section.items" class="property-row">
                        <span class="property-label">
                          {{ item.label }}:
                          <mat-icon class="info-icon" [matTooltip]="item.tooltip" matTooltipPosition="above">info</mat-icon>
                        </span>
                        <span class="property-value">{{ isNumber(item.value) ? (item.value | number : '1.0-3') : item.value }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Preventivi">
                <div class="tab-scroll">
                  <div *ngIf="detail.tabs.quotations.length === 0" class="empty-message">Nessun preventivo per questa area</div>
                  <div
                    *ngFor="let item of detail.tabs.quotations; let i = index"
                    class="array-item"
                    (mouseenter)="onQuotationHover(i, item)"
                    (mouseleave)="onQuotationLeave(i, item)"
                  >
                    <div class="array-item-header" (click)="toggleQuotation(i)">
                      <span>{{ item['Codice Preventivo'] || item['Id'] || '#' + (i + 1) }}</span>
                      <div class="array-item-actions">
                        <mat-icon (click)="copyQuotationContent(item); $event.stopPropagation()" title="Copia">content_copy</mat-icon>
                        <mat-icon (click)="centerOnQuotation(i); $event.stopPropagation()" title="Centra mappa">my_location</mat-icon>
                        <mat-icon>{{ isQuotationExpanded(i) ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
                      </div>
                    </div>
                    <div class="array-item-body" *ngIf="isQuotationExpanded(i)">
                      <div *ngFor="let entry of objectEntries(item)" class="property-row">
                        <span class="property-label">{{ entry[0] }}:</span>
                        <span class="property-value">{{ entry[1] }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </ng-container>

          <ng-template #standardDetail>
            <app-report-dialog
              *ngIf="!isPsaObject(detail.data)"
              [data]="detail.data"
              [isDialog]="false"
              [styleConfig]="customReportStyle"
              (detailRequested)="addDetailFromFeature($event)"
              [properties]="detail.properties"
              [showStructure]="shouldShowStructure(detail)"
              style="height: 90%; display: block"
            ></app-report-dialog>
            <!-- PSA -->
            <app-psa-element-detail
              *ngIf="isPsaObject(detail.data)"
              [data]="detail.data"
              [isDialog]="false"
              (detailRequested)="addDetailFromFeature($event)"
            ></app-psa-element-detail>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>
</section>
